import React, { useState, useEffect } from "react";
import axios from "axios";
import "../App.css"; // Importa el CSS externo
import { exportarAExcel } from "../utils/exportExcel";

function RegistroForm() {
  const [fecha, setFecha] = useState("");
  const [formData, setFormData] = useState({
    fecha: "",
    material: "",
    cantidad: "",
    cliente: "",
    horasOp: "",
    observaciones: "",
  });
  const apiurl = process.env.REACT_APP_API_URL;
  useEffect(() => {
    const hoy = new Date();
    const yyyy = hoy.getFullYear();
    const mm = String(hoy.getMonth() + 1).padStart(2, "0");
    const dd = String(hoy.getDate()).padStart(2, "0");
    setFecha(`${yyyy}-${mm}-${dd}`);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    formData.fecha = fecha;

    try {
      await axios.post(`${apiurl}/registros`, formData);
      alert("✅ Registro enviado correctamente");
      setFormData({
        fecha: "",
        material: "",
        cantidad: "",
        cliente: "",
        horasOp: "",
        observaciones: "",
      });
    } catch (error) {
      console.error("Error al enviar el formulario:", error);
      alert("❌ Error al guardar los datos");
    }
  };
  const formatearFecha = (fechaIso) => {
    const fecha = new Date(fechaIso);
    const dia = String(fecha.getDate()).padStart(2, "0");
    const mes = String(fecha.getMonth() + 1).padStart(2, "0"); // ¡Mes comienza en 0!
    const anio = fecha.getFullYear();
    return `${dia}-${mes}-${anio}`;
  };
  const handleExcel = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.get(`${apiurl}/getRegistros`);
      const data = response.data.map((item) => ({
        ...item,
        fecha: formatearFecha(item.fecha),
      }));
      exportarAExcel(data, "registros_residuos.xlsx");
    } catch (error) {
      console.error("Error al obtener los registros:", error);
    }
  };

  return (
    <div className="wrapper">
      <div className="form-side">
        <form onSubmit={handleSubmit}>
          <h2>Registro de Residuos</h2>

          <label>Fecha:</label>
          <input
            type="date"
            name="fecha"
            value={fecha}
            onChange={(e) => setFecha(e.target.value)}
            required
          />

          <label>Material:</label>
          <input
            type="text"
            name="material"
            value={formData.material}
            onChange={handleChange}
            required
          />

          <label>Cantidad (kg):</label>
          <input
            type="number"
            step="0.01"
            name="cantidad"
            value={formData.cantidad}
            onChange={handleChange}
            required
          />

          <label>Cliente:</label>
          <input
            type="text"
            name="cliente"
            value={formData.cliente}
            onChange={handleChange}
            required
          />
          <label>Horas operación:</label>
          <input
            type="number"
            value={formData.horasOp}
            onChange={(e) =>
              setFormData({ ...formData, horasOp: e.target.value })
            }
          />

          <label>Observaciones:</label>
          <textarea
            name="observaciones"
            value={formData.observaciones}
            onChange={handleChange}
          ></textarea>

          <div className="form-buttons">
            <button type="submit">Guardar</button>
            <button
              style={{ fontSize: "15px", backgroundColor: "#064e3b" }}
              onClick={handleExcel}
            >
              Descargar Registros
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default RegistroForm;
